import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import iconSprite from "../../../assets/icon-sprite.svg";
import { fetchLenders, assignLoan } from "../../actions/p2p";

class AssignLoan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchQuery: "",
      selectedLender: "",
      lenderId: "",
      loading: false,
      lenders: [],
    };
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
  }

  handleSearch = async () => {
    const { searchQuery } = this.state;
    try {
      const lendersData = await fetchLenders(1, searchQuery);
      const user_id = lendersData.data.loans[0]?.user_id || "";
      this.setState({
        lenders: lendersData.data.loans,
        lenderId: user_id,
        selectedLender: lendersData.data.loans.length === 1 ? user_id : null,
      });
    } catch (error) {
      console.error("Error fetching lenders:", error);
    }
  };

  handleOnChange = (e) => {
    const selectedValue = e.target.value;
    this.setState({ searchQuery: selectedValue });
  };

  handleSearchButtonClick = () => {
    this.handleSearch();
  };

  handleOnSubmit = async (e) => {
    e.preventDefault();
    const { onClose, onSubmit, data } = this.props;
    const { selectedLender } = this.state;
    const loanId = data.id;
    this.setState({ loading: true }, async () => {
      try {
        const response = await assignLoan({
          id: loanId,
          lender_user_id: selectedLender,
        });
        if (response.status !== "success") throw new Error(response?.message);
        toast.success(response?.message);
        onClose?.();
        onSubmit?.();
      } catch (error) {
        toast.error(
          error.response?.data?.message ||
            error.response?.statusText ||
            error.message ||
            "Seems like something went wrong with your request. Please try again."
        );
      } finally {
        this.setState({ loading: false });
      }
    });
  };



  render() {
    const { searchQuery, selectedLender, loading, lenders } = this.state;
    const { visible, onClose } = this.props;
    const isLenderSelected = selectedLender !== null;

    return (
      <Modal className="modal fade" centered show={visible} onHide={onClose}>
        <form
          name="lender_user_id"
          className="modal-form"
          onSubmit={(e) => this.handleOnSubmit(e)}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Assign Loan</h5>
              <button type="button" className="close" onClick={onClose}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="form-group" style={{ margin: 20 }}>
              <label htmlFor="lender_user_id" className="form-label">
                Lender's Name
              </label>
              <div className="input-with-icon">
                <input
                  type="text"
                  id="lender_user_id"
                  name="lender_user_id"
                  placeholder="Search by first name, last name, or email..."
                  className="form-control"
                  value={searchQuery}
                  onChange={this.handleOnChange}
                />
                <button
                  type="button"
                  className="search-button"
                  onClick={this.handleSearchButtonClick}
                  style={{
                    marginTop: 10,
                    padding: 4,
                    backgroundColor: "lightblue",
                    color: "white",
                  }}
                >
                  Search
                </button>
              </div>
              <select
                className="form-control mt-2"
                id="lender_user_id"
                name="lender_user_id"
                onChange={(e) => {
                  this.setState({ selectedLender: e.target.value });
                }}
                value={selectedLender}
              >
                <option disabled>Select Lender</option>
                {lenders?.map((lender) => (
                  <option key={lender.id} value={lender.user_id}>
                    {lender.first_name} {lender.last_name}
                  </option>
                ))}
              </select>

              <span className="input-icon">
                <svg width="24" height="24">
                  <use xlinkHref={`${iconSprite}#dropdown`}></use>
                </svg>
              </span>
            </div>
            <div className="modal-footer">
              <button
                type="submit"
                disabled={!isLenderSelected || loading}
                className="btn btn-primary"
              >
                {loading ? "Assigning Loan..." : "Assign Loan"}
              </button>
            </div>
          </div>
        </form>
      </Modal>
    );
  }
}

export default AssignLoan;
